import React from "react"

export const MarkIcon = () => {
  return (
    <div className="contacts__icon">
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5001 0C9.67258 0 5 5.14002 5 13.7501C5 23.1426 16.1501 34.1777 16.6251 34.6427C17.1111 35.1191 17.889 35.1191 18.375 34.6427C18.85 34.1776 30.0001 23.1426 30.0001 13.7501C30.0002 5.14002 25.3277 0 17.5001 0ZM17.5001 31.9514C14.9151 29.1939 7.50006 20.6826 7.50006 13.7501C7.50006 6.49999 11.0513 2.49999 17.5001 2.49999C23.9489 2.49999 27.5001 6.49999 27.5001 13.7501C27.5001 20.6726 20.0839 29.1927 17.5001 31.9514Z"
          fill="white"
        />
        <path
          d="M17.4998 5.00012C14.048 5.00012 11.2498 7.79836 11.2498 11.2501C11.2498 14.7019 14.048 17.5001 17.4998 17.5001C20.9515 17.5001 23.7498 14.7019 23.7498 11.2501C23.7457 7.80004 20.9499 5.00422 17.4998 5.00012ZM17.4998 15.0002C15.4287 15.0002 13.7497 13.3212 13.7497 11.2501C13.7497 9.17905 15.4287 7.50011 17.4998 7.50011C19.5708 7.50011 21.2498 9.17905 21.2498 11.2501C21.2498 13.3212 19.5708 15.0002 17.4998 15.0002Z"
          fill="white"
        />
      </svg>
    </div>
  )
}
